import React from "react";

export const PharmGKBLevelHelperText = (
  <table className="tw-flex-nowrap">
    <thead>
      <tr>
        <th>Level of Evidence</th>
        <th>Standard scoring range</th>
        <th>Rare variant scoring range</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>1A</td>
        <td>≥80</td>
        <td>≥80</td>
      </tr>
      <br />
      <tr>
        <td>1B</td>
        <td>25-79.9375</td>
        <td>10-79.9375</td>
      </tr>
      <br />
      <tr>
        <td>2A</td>
        <td>
          {" "}
          <span>8-24.9375 and variant in a Tier 1 VIP </span>
        </td>
        <td>
          <span>3-9.9375 and variant in a Tier 1 VIP</span>
        </td>
      </tr>
      <br />
      <tr>
        <td>2B</td>
        <td>8-24.9375</td>
        <td>3-9.9375</td>
      </tr>
      <br />
      <tr>
        <td>3</td>
        <td>0-7.9375</td>
        <td>0-2.9375</td>
      </tr>
      <br />
      <tr>
        <td>4</td>
        <td>&lt;0</td>
        <td>&lt;0</td>
      </tr>
    </tbody>
  </table>
);
